<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Справка об обучении"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeTrainingCertificate"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-show="!showOrganizationName"
        v-model="trainingCertificate.organization"
        :items="dictionaries.organization"
        item-text="name"
        clearable outlined rounded dense return-object persistent-hint
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        hint="Если вы не нашли название университета в выпадающем списке, введите название вручную, нажав на карандаш"
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowOrganizationName"
        @input="setTrainingCertificate"
      >
        <template #label>
          <span class="required">Образовательная организация</span>
        </template>

      </v-autocomplete>

      <v-text-field
        v-show="showOrganizationName"
        v-model="trainingCertificate.organizationName"
        placeholder="Введите данные"
        rounded outlined dense
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowOrganizationName"
        @input="setTrainingCertificate"
      >
        <template #label>
          <span class="required">Наименование образовательной организации</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="trainingCertificate.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setTrainingCertificate"
      >
        <template #label>
          <span class="required">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="trainingCertificate.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setTrainingCertificate"
      >
        <template #label>
          <span class="required">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <DatePicker
        label="Дата выдачи"
        required
        :prop-date="trainingCertificate.issueDate"
        @set-date="setIssueDate"
      />
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл справки об обучении"
        :ref-id="trainingCertificate.id"
        ref-class-name="TrainingCertificate"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {TrainingCertificate} from "@/models"
import {mapGetters} from "vuex";

export default {
  name: "TrainingCertificate",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: TrainingCertificate
  },

  data: () => ({
    trainingCertificate: new TrainingCertificate(),

    showOrganizationName: false,
  }),

  computed: {
    ...mapGetters('dictionaries', ['dictionaries'])
  },

  methods: {
    changeShowOrganizationName() {
      this.showOrganizationName = !this.showOrganizationName

      this.showOrganizationName ? this.trainingCertificate.organization = null
                                : this.trainingCertificate.organizationName = null
    },

    setTrainingCertificate() {
      this.$emit('set-data', this.trainingCertificate)
    },

    removeTrainingCertificate() {
      this.$emit('remove', this.trainingCertificate)
    },

    setIssueDate(value) {
      this.trainingCertificate.issueDate = value
      this.setTrainingCertificate()
    },

    setFiles(value) {
      this.trainingCertificate.filesData = value
      this.setTrainingCertificate()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.trainingCertificate = TrainingCertificate.build(this.item)

        if (!this.trainingCertificate.organization?.id && this.trainingCertificate.organizationName) {
          this.showOrganizationName = true
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
